'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _colors = require('../settings/colors');

var _colors2 = _interopRequireDefault(_colors);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var IconInfo = function IconInfo(_ref) {
  var color = _ref.color,
      custom = _objectWithoutProperties(_ref, ['color']);

  return _react2.default.createElement(
    'svg',
    _extends({ width: '24px', height: '24px', viewBox: '0 0 24 24' }, custom),
    _react2.default.createElement(
      'g',
      { transform: 'translate(3, 3)', fill: color },
      _react2.default.createElement('path', { d: 'M9.57,7.773 L9.57,12.177 C9.57,12.48225 9.495,12.7125 9.3525,12.86925 C9.21,13.02525 9.0225,13.10325 8.7975,13.10325 C8.5725,13.10325 8.3925,13.023 8.2575,12.86325 C8.115,12.7035 8.0475,12.47475 8.0475,12.177 L8.0475,7.818 C8.0475,7.5165 8.115,7.29 8.2575,7.137 C8.3925,6.98475 8.5725,6.90825 8.7975,6.90825 C9.0225,6.90825 9.21,6.98475 9.3525,7.137 C9.495,7.29 9.57,7.5015 9.57,7.773 Z M8.82,6.1995 C8.6025,6.1995 8.4225,6.13425 8.2725,6.00375 C8.1225,5.874 8.0475,5.6895 8.0475,5.45175 C8.0475,5.23575 8.1225,5.058 8.28,4.9185 C8.43,4.779 8.61,4.70925 8.82,4.70925 C9.015,4.70925 9.1875,4.77225 9.3375,4.899 C9.495,5.02575 9.57,5.2095 9.57,5.45175 C9.57,5.68575 9.495,5.8695 9.345,6.00075 C9.195,6.1335 9.0225,6.1995 8.82,6.1995 L8.82,6.1995 Z', id: 'Fill-1177' }),
      ' ',
      _react2.default.createElement('path', { d: 'M8.835,1.5 C6.8775,1.5 5.0325,2.26275 3.6525,3.6465 C2.265,5.03175 1.5,6.87375 1.5,8.832 C1.5,10.79175 2.265,12.633 3.6525,14.0175 C5.0325,15.402 6.8775,16.164 8.835,16.164 C10.7925,16.164 12.6375,15.40125 14.0175,14.016 C16.8825,11.157 16.875,6.5055 14.0175,3.6465 C12.6375,2.26275 10.7925,1.5 8.835,1.5 Z M8.835,17.664 C6.4725,17.664 4.26,16.746 2.5875,15.07875 C0.9225,13.41075 0,11.19225 0,8.832 C0,6.4725 0.9225,4.254 2.5875,2.586 C4.26,0.91875 6.4725,0 8.835,0 C11.1975,0 13.41,0.91875 15.0825,2.586 C18.525,6.02925 18.525,11.6325 15.0825,15.07725 C13.41,16.74525 11.1975,17.664 8.835,17.664 L8.835,17.664 Z', id: 'Fill-1178' }),
      ' '
    )
  );
};

IconInfo.propTypes = {
  color: _propTypes2.default.string
};

IconInfo.defaultProps = {
  color: _colors2.default.icons
};

IconInfo.displayName = 'IconInfo';

exports.default = IconInfo;
module.exports = exports.default;